// extracted by mini-css-extract-plugin
export default {"wrapper":"Qo-z","viewport":"Ro-z","container":"So-z","slide":"To-z"};